(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kama-bundle-chooser"] && !Shopify.designMode) return;
  try {
    
function initialiseBundleChoosers(){document.querySelectorAll('.kj-bundles').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const filter=root.querySelector('.kj-bundles__filter'),select=filter.querySelector('select'),cards=[...root.querySelectorAll('[data-model]')];filter.hidden=false;const update=()=>{let count=0;cards.forEach(card=>{card.hidden=card.dataset.model!==select.value;if(!card.hidden)count++;});filter.querySelector('[role=status]').textContent=count+' setups to compare';};select.addEventListener('change',update);update();});}initialiseBundleChoosers();document.addEventListener('shopify:section:load',initialiseBundleChoosers);document.addEventListener('shopify:block:select',event=>{const card=event.target.closest('[data-model]');if(!card)return;const select=card.closest('.kj-bundles')?.querySelector('select');if(select){select.value=card.dataset.model;select.dispatchEvent(new Event('change'));}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kama-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kama-collections-directory"] && !Shopify.designMode) return;
  try {
    
  function initialiseKamaDirectories(){
    document.querySelectorAll('.kama-directory').forEach(root=>{
      if(root.dataset.ready)return;root.dataset.ready='true';
      const search=root.querySelector('.kama-directory__search'),input=search.querySelector('input'),status=search.querySelector('[role=status]'),cards=[...root.querySelectorAll('[data-category]')],empty=root.querySelector('.kama-directory__empty');
      search.hidden=false;
      function filter(){const query=input.value.trim().toLocaleLowerCase();let count=0;for(const card of cards){card.hidden=!card.dataset.category.toLocaleLowerCase().includes(query);if(!card.hidden)count++;}status.textContent=count+' '+(count===1?'category':'categories');empty.hidden=count!==0;}
      input.addEventListener('input',filter);filter();
    });
  }
  initialiseKamaDirectories();document.addEventListener('shopify:section:load',initialiseKamaDirectories);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kama-comparison-studio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kama-comparison-studio')) {
  customElements.define('kama-comparison-studio', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.select = this.querySelector('[data-rival-select]');
      this.groups = [...this.querySelectorAll('.kvs__group')];
      this.labels = JSON.parse(this.querySelector('[data-comparison-labels]').textContent);
      this.expandButton = this.querySelector('[data-expand]');
      this.media = matchMedia('(max-width:749px)');
      this.applyViewport = () => {
        this.select.querySelector('[value="all"]').hidden = this.media.matches;
        this.select.value = this.media.matches ? (this.dataset.rival === 'all' ? 'comp1' : this.dataset.rival) : 'all';
        this.dataset.rival = this.select.value;
      };
      this.applyViewport();
      this.media.addEventListener('change', this.applyViewport, {signal});
      this.select.addEventListener('change', () => { this.dataset.rival = this.select.value; }, {signal});
      this.updateExpand = () => {
        const allOpen = this.groups.every(group => group.open);
        this.expandButton.setAttribute('aria-expanded', String(allOpen));
        this.expandButton.querySelector('[data-expand-label]').textContent = allOpen ? this.labels.collapse : this.labels.expand;
      };
      this.expandButton.addEventListener('click', () => {
        const open = !this.groups.every(group => group.open);
        this.groups.forEach(group => { group.open = open; });
        this.updateExpand();
      }, {signal});
      this.groups.forEach(group => group.addEventListener('toggle', this.updateExpand, {signal}));
      document.addEventListener('shopify:block:select', event => {
        if (this.contains(event.target)) { const group = event.target.closest('details'); if (group) group.open = true; }
      }, {signal});
      this.querySelector('.kvs__toolbar').hidden = false;
      this.updateExpand();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kama-featured-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kama-featured-carousel')) {
  customElements.define('kama-featured-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.track.querySelectorAll('slideshow-component').forEach(gallery => gallery.setAttribute('disabled','true'));
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.status = this.querySelector('[data-status]');
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, {...options, passive:true});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({left:event.key === 'Home' ? 0 : (rtl ? -1 : 1) * this.track.scrollWidth, behavior:this.behavior()});
        }
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.querySelector('[data-controls]').hidden = false;
      this.update();
    }
    behavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'; }
    move(direction) {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = this.slides[0].getBoundingClientRect().width + gap;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollBy({left:direction * step * (rtl ? -1 : 1), behavior:this.behavior()});
    }
    update() {
      const rect = this.track.getBoundingClientRect();
      const visible = this.slides.map((slide,index) => ({rect:slide.getBoundingClientRect(),index})).filter(item => Math.min(item.rect.right,rect.right) - Math.max(item.rect.left,rect.left) > item.rect.width * .5);
      const first = visible.length ? visible[0].index + 1 : 1;
      const last = visible.length ? visible[visible.length - 1].index + 1 : first;
      const status = this.dataset.statusTemplate.replace('[first]',first).replace('[last]',last).replace('[total]',this.slides.length);
      if (this.status.textContent !== status) this.status.textContent = status;
      const offset = Math.abs(this.track.scrollLeft);
      this.previous.disabled = offset <= 3;
      this.next.disabled = offset >= this.track.scrollWidth - this.track.clientWidth - 2;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kama-grill-bundles"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kama-featured-carousel')) {
  customElements.define('kama-featured-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.track.querySelectorAll('slideshow-component').forEach(gallery => gallery.setAttribute('disabled','true'));
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.status = this.querySelector('[data-status]');
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, {...options, passive:true});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({left:event.key === 'Home' ? 0 : (rtl ? -1 : 1) * this.track.scrollWidth, behavior:this.behavior()});
        }
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.querySelector('[data-controls]').hidden = false;
      this.update();
    }
    behavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'; }
    move(direction) {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = this.slides[0].getBoundingClientRect().width + gap;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollBy({left:direction * step * (rtl ? -1 : 1), behavior:this.behavior()});
    }
    update() {
      const rect = this.track.getBoundingClientRect();
      const visible = this.slides.map((slide,index) => ({rect:slide.getBoundingClientRect(),index})).filter(item => Math.min(item.rect.right,rect.right) - Math.max(item.rect.left,rect.left) > item.rect.width * .5);
      const first = visible.length ? visible[0].index + 1 : 1;
      const last = visible.length ? visible[visible.length - 1].index + 1 : first;
      const status = this.dataset.statusTemplate.replace('[first]',first).replace('[last]',last).replace('[total]',this.slides.length);
      if (this.status.textContent !== status) this.status.textContent = status;
      const offset = Math.abs(this.track.scrollLeft);
      this.previous.disabled = offset <= 3;
      this.next.disabled = offset >= this.track.scrollWidth - this.track.clientWidth - 2;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kama-grill-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kama-home-sale"] && !Shopify.designMode) return;
  try {
    
function updateKamaHomeSaleBanners() {
  document.querySelectorAll('.kh-sale[data-sale-launch]').forEach((banner) => {
    if (Date.now() < Date.parse(banner.dataset.saleLaunch)) return;
    banner.querySelector('.kh-sale__eyebrow').textContent = banner.dataset.liveStatus;
    banner.querySelector('.kh-sale__intro').textContent = banner.dataset.liveIntro;
    const button = banner.querySelector('.kh-sale__button');
    if (button) {
      button.querySelector('[data-sale-button-label]').textContent = banner.dataset.liveLabel;
      button.setAttribute('href', banner.dataset.liveLink);
    }
  });
}
updateKamaHomeSaleBanners();
setInterval(updateKamaHomeSaleBanners, 1000);
document.addEventListener('shopify:section:load', updateKamaHomeSaleBanners);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kama-statement-strip"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-kama-scroll-pause]');
    if (!button) return;
    const paused = button.getAttribute('aria-pressed') !== 'true';
    button.setAttribute('aria-pressed', String(paused));
    button.setAttribute('aria-label', paused ? 'Resume scrolling' : 'Pause scrolling');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kama-stockist-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kama-stockist-finder')) {
  customElements.define('kama-stockist-finder',class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready=true;
      this.events=new AbortController();
      const options={signal:this.events.signal};
      const input=this.querySelector('[data-search]'),cards=[...this.querySelectorAll('[data-card]')],count=this.querySelector('[data-count]');
      const layout=this.querySelector('.ks-layout'),panel=this.querySelector('[data-map-panel]'),frame=this.querySelector('[data-map-frame]');
      const buttons=[...this.querySelectorAll('[data-map]')],name=this.querySelector('[data-map-name]'),help=this.querySelector('[data-map-help]');
      const initialName=name?.textContent,initialHelp=help?.textContent;
      let selected=null;
      this.mobile=matchMedia('(max-width:989px)');
      const positionMap=()=>{
        if (!panel) return;
        const card=selected?.closest('[data-card]');
        if (this.mobile.matches&&card&&!card.hidden) {
          if (card.nextElementSibling!==panel) card.insertAdjacentElement('afterend',panel);
        } else if (panel.parentElement!==layout) layout.append(panel);
      };
      const resetMap=()=>{
        selected=null;
        buttons.forEach(button=>button.setAttribute('aria-expanded','false'));
        if (panel) {
          panel.removeAttribute('data-active');frame.hidden=true;frame.removeAttribute('src');
          name.textContent=initialName;help.textContent=initialHelp;positionMap();
        }
      };
      const normalize=value=>value.toLocaleLowerCase().replace(/[^a-z0-9]/g,'');
      const filter=()=>{
        const term=normalize(input.value);let found=0;
        cards.forEach(card=>{card.hidden=!normalize(card.dataset.searchText).includes(term);if(!card.hidden)found++});
        count.textContent=found+' '+count.dataset.label;
        this.querySelector('[data-empty]').hidden=found!==0;
        if (selected?.closest('[data-card]').hidden) resetMap();
      };
      input.addEventListener('input',filter,options);
      this.querySelector('[data-clear]').addEventListener('click',()=>{input.value='';filter();input.focus()},options);
      buttons.forEach(button=>button.addEventListener('click',()=>{
        if (selected===button) { resetMap();button.focus({preventScroll:true});return; }
        selected=button;
        buttons.forEach(item=>item.setAttribute('aria-expanded',String(item===button)));
        name.textContent=button.dataset.name;help.textContent=button.dataset.map;
        frame.src='https://maps.google.com/maps?q='+encodeURIComponent(button.dataset.map)+'&output=embed';frame.hidden=false;
        panel.setAttribute('data-active','');positionMap();
        panel.focus({preventScroll:true});
        panel.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:this.mobile.matches?'start':'nearest'});
      },options));
      this.onLayoutChange=positionMap;
      this.mobile.addEventListener('change',this.onLayoutChange);
    }
    disconnectedCallback() {
      this.events?.abort();
      this.mobile?.removeEventListener('change',this.onLayoutChange);
      this.ready=false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kama-summer-sale"] && !Shopify.designMode) return;
  try {
    
function updateKamaSaleBanners() {
  document.querySelectorAll('[data-sale-launch]').forEach((banner) => {
    if (Date.now() < Date.parse(banner.dataset.saleLaunch)) return;
    banner.querySelector('.kg-summer__eyebrow').textContent = banner.dataset.liveStatus;
    banner.querySelector('.kg-summer__intro').textContent = banner.dataset.liveIntro;
    const button = banner.querySelector('.kg-summer__button');
    if (button) {
      button.querySelector('[data-sale-button-label]').textContent = banner.dataset.liveLabel;
      button.setAttribute('href', banner.dataset.liveLink);
    }
  });
}
updateKamaSaleBanners();
setInterval(updateKamaSaleBanners, 1000);
document.addEventListener('shopify:section:load', updateKamaSaleBanners);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
